// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"96d13f64","139":"8e22b748","192":"e1496c60","438":"ca2709a6","450":"0688887f","469":"3abc9312","521":"4a7b205c","563":"293f8a7d","569":"7e5e0714","633":"6e93814c","650":"64988e4a","818":"182dcc46","852":"9151ca65","952":"e5de2479"}[chunkId] + ".chunk.js";
};